import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '@/api/client';

export default function AuditTab() {
  const { data: logs = [] } = useQuery({
    queryKey: ['adm-audit'],
    queryFn: async () => (await api.get('/admin/audit-logs')).data,
  });
  return (
    <div className="card-moj overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-moj-cream"><tr><th className="text-left p-3">When</th><th className="text-left p-3">Actor</th><th className="text-left p-3">Action</th><th className="text-left p-3">Entity</th><th className="text-left p-3">Details</th></tr></thead>
        <tbody>
          {logs.slice(0, 100).map((log) => (
            <tr key={log.id} className="border-t">
              <td className="p-3 text-xs whitespace-nowrap">{log.created_at?.slice(0, 19).replace('T', ' ')}</td>
              <td className="p-3 text-xs">{log.actor_profile_id || '—'}</td>
              <td className="p-3"><span className="px-2 py-0.5 rounded-full bg-moj-gold/20 text-xs font-bold">{log.action}</span></td>
              <td className="p-3 text-xs">{log.entity_type}</td>
              <td className="p-3 text-xs text-moj-charcoal/60">{JSON.stringify(log.details || {})}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
